export default [{
  path: '/NewsCenterRes',//新闻搜索结果页
  name: 'resultPage',
  component: () => import('@/view/NewsCenterSpa/result.vue')
},{
  path: '/NewsCenterResDet',//新闻搜索结果详情页
  name: 'ResDetNPage',
  component: () => import('@/view/NewsCenterSpa/resultDetail.vue')
},{
  path: '/NewsCenterService',//新闻中心服务
  name: 'serviceN',
  component: () => import('@/view/NewsCenterSpa/service.vue')//
  },]




// WEBPACK FOOTER //
// ./src/router/newsCenterSpa.js